// Display helpers only: never write this label back into a person's name.
export function userLabel(person) {
    const username = String(person?.username || '').trim();
    const name = String(person?.name || person?.realname || '').trim() || username;
    return username && username !== name ? `${name} (${username})` : name;
}

export function userIdentityEl(person) {
    const username = String(person?.username || '').trim();
    const name = String(person?.name || person?.realname || '').trim() || username;
    const identity = document.createElement('span');
    identity.className = 'user-identity';
    const primary = document.createElement('span');
    primary.className = 'user-realname';
    primary.textContent = name;
    identity.appendChild(primary);
    if (username && username !== name) {
        identity.appendChild(document.createTextNode(' '));
        const secondary = document.createElement('span');
        secondary.className = 'user-username';
        secondary.textContent = `(${username})`;
        identity.appendChild(secondary);
    }
    return identity;
}
